/* eslint-disable block-scoped-var */
import * as moment from 'moment';
/**
 * Verifica se a data repassada é o ultimo dia do mes
 * @param data data a ser verificada
 */
export function isLastDayOfMonth(data: Date): boolean {
  return (
    moment(data)
      .add({ days: 1 })
      .month() !== data.getMonth()
  );
}

/**
 * Estrategia utilizada para corrigir time zone das datas exibidas no grid.
 * @param data para ser convertida
 * @returns a data convertida com o timezone correto
 */
export function convertTimeZone(data: string | Date) {
  const timeZone = new Date(data).getTimezoneOffset() * 60 * 1000;
  const time = new Date(data).getTime();
  return new Date(time + timeZone);
}

/**
 * Estrategia utilizada para corrigir time zone das datas exibidas no grid.
 * @param data para ser convertida
 * @returns a data convertida com o timezone correto
 */
export function convertTimeZoneMinus(data: string | Date) {
  const timeZone = new Date(data).getTimezoneOffset() * 60 * 1000;
  const time = new Date(data).getTime();
  return new Date(time - timeZone);
}

/**
 * Função responsável por converter a data passada em um formato que informa o fuso horário registrado no sistema
 * @param date
 * @returns
 */
export function convertDateToMaskTimezone(date: Date | string) {
  if (typeof date === 'string') {
    var dateStr = date;
    var timezone = new Date(date).getTimezoneOffset() / 60;
    if (timezone < 0) {
      // ENTÃO É UM FUSO HORARIO DE + HORAS
      timezone *= -1;
      if (timezone < 10) {
        return `${dateStr}+0${timezone}00`;
      } else {
        return `${dateStr}+${timezone}00`;
      }
    } else {
      // É UM FUSO HORARIO DE - HORAS
      timezone *= -1;
      if (timezone < 10) {
        return `${dateStr}-0${timezone * -1}00`;
      } else {
        return `${dateStr}-${timezone * -1}00`;
      }
    }
  } else {
    if (moment.isMoment(date)) date = moment(date).toDate();
    var timezone = date.getTimezoneOffset() / 60;
    if (timezone < 0) {
      // ENTÃO É UM FUSO HORARIO DE + HORAS
      timezone *= -1;
      if (timezone < 10) {
        return `${date.getFullYear()}-${date.getUTCMonth() +
          1}-${date.getDate()}+0${timezone}00`;
      } else {
        return `${date.getFullYear()}-${date.getUTCMonth() +
          1}-${date.getDate()}+${timezone}00`;
      }
    } else {
      // É UM FUSO HORARIO DE - HORAS
      timezone *= -1;
      if (timezone < 10) {
        return `${date.getFullYear()}-${date.getUTCMonth() +
          1}-${date.getDate()}-0${timezone * -1}00`;
      } else {
        return `${date.getFullYear()}-${date.getUTCMonth() +
          1}-${date.getDate()}-${timezone * -1}00`;
      }
    }
  }
}
/**
 * Zera as horas de uma data
 * @param data
 * @returns
 */
export function zeroHours(data: Date) {
  return new Date(data.setHours(0, 0, 0, 0));
}

/**
 * Função para converter a data no padrão americano
 * @param data para ser convertida
 * @returns
 */
export function DateConvert(data: any) {
  if (typeof data === 'string') var [dd, mm, yyyy] = data.split('/');
  else [dd, mm, yyyy] = data[0].split('/');
  return `${yyyy}-${mm}-${dd}`;
}
